import type React from 'react';

import { Spinner } from '@change/ds-core-ui/Spinner';

export const PhotoProcessing: React.FC<EmptyProps> = () => {
	return (
		<div className="overflow-hidden" aria-hidden="true">
			<div className="flex h-full items-center justify-center overflow-hidden pb-[56.25%]">
				<Spinner className="size-4" />
			</div>
		</div>
	);
};
